<ion-content class="modal-border">
  <ion-header>
    <ion-toolbar>
      <ion-title>{{modalHeaderText}}</ion-title>
    </ion-toolbar>
  </ion-header>

  <div class="ion-padding">
    <form>
      <ngx-extended-pdf-viewer
        [src]="PDFLocation"
        [showSidebarButton]="false"
        [showFindButton]="false"
        [showPagingButtons]="true"
        [showZoomButtons]="true"
        [showPresentationModeButton]="false"
        [showOpenFileButton]="false"
        [showPrintButton]="true"
        [showDownloadButton]="true"
        [showSecondaryToolbarButton]="false"
        [showRotateButton]="true"
        [showHandToolButton]="false"
        [showSpreadButton]="false"
        [showPropertiesButton]="false"
        [mobileFriendlyZoom]="zoom"
        useBrowserLocale="true"
        height="65vh"
        [zoom]="'page-width'"
        (pagesLoaded)="onPagesLoaded($event)"
        (pageRendered)="onPageRendered($event)"
      >
      </ngx-extended-pdf-viewer>
    </form>
    <form [formGroup]="procedureForm">
      <ion-item *ngIf="must_accept == true">
        <ion-checkbox
          [(ngModel)]="procedure.AcceptedDocument"
          value="{{procedure.AcceptedDocument}}"
          formControlName="fc_AcceptDocument"
        ></ion-checkbox>
        <ion-label> Accept this procedure</ion-label>
      </ion-item>
      <ion-button (click)="onCloseUpload()" class="menuitem-ion-button">
        <ion-icon name="checkmark-circle-outline"></ion-icon>Save
      </ion-button>
    </form>
  </div>
</ion-content>
